import { RefObject, useEffect } from 'react'

export const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  handler: () => void,
  excludeRefs: RefObject<HTMLElement | null>[] = []
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Check if click was inside the main ref
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return
      }

      // Check if click was inside any of the excluded refs
      for (const excludeRef of excludeRefs) {
        if (excludeRef?.current?.contains(event.target as Node)) {
          return
        }
      }

      handler()
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler, excludeRefs])
}
